import { jwtDecode } from "jwt-decode";
import { Endpoint, IpFilterPolicy, IpFilterRow, IpFilterType, MetricsTimeRange } from "src/types";

export const checkIsDefined = (value: any) =>
  value !== undefined && value !== null;
export interface FieldGetters {
  [name: string]: (row: any, name: string) => any;
}

// Ajout d'une fonction utilitaire pour récupérer les paramètres de l'URL
export const getUrlParameters = (): any => {
  const params = new URLSearchParams(window.location.search);
  return {
    currentCode: params.get("code"),
    id: params.get("organizationId"),
  };
};
export interface Backend {
  port: any;
  type: string;
  address?: string;
  Address?: string;
  serviceName?: string;
  protocol?: string;
  isSelected?: boolean;
  filteredOptions?: any[]; 
  showAddServiceButton?: boolean,
  status?: string;
  weight?: number;
}

export const backendRefactorings = (data: Backend[]): Backend[] => {
  return (
    data?.map((item: Backend) => {
      const newItem = { ...item }; // Copie de l'objet
      if (newItem.port) {
        newItem.port = parseInt(newItem.port, 10);
      }
      if (item.type === "external") {
        delete newItem.serviceName; // Supprime la clé `service`
      }
      if (item.type === "local") {
        delete newItem.address; // Supprime la clé `adressPort`
      }
      if (item.type === "local") {
        delete newItem.protocol; // Supprime la clé `adressPort`
      }
      if(item.type === "local"){
        delete newItem.filteredOptions
        delete newItem.showAddServiceButton
      }
      return newItem;
    }) || []
  );
};
export enum EGatewayStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export const truncateText = (text: string, endTo = 25): string =>
  text?.length > endTo ? `${text.substring(0, endTo)}...` : text;

export const isFieldWithValue = (field: string): boolean =>
  field !== undefined && field !== null && field.replace(/\s/g, "")?.length > 0;

export const isValidURL = (value: string) => {
  try {
    if (!value?.length) {
      return false;
    }
    let newValue = value;
    if (!value.startsWith("http://") && !value.startsWith("https://")) {
      newValue = `https://${value}`;
    }

    const url = new URL(newValue);
    if (/https?:\/\/[^\s/$.?#].[^\s]*/.test(url.hostname)) {
      return false;
    }

    return true;
  } catch (_) {
    return false;
  }
};

export const isValidEmail = (value: string) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(value);
}

export const hasValue = (data: any) => data !== undefined && data !== null;

export const chartDataMapper = (
  value: keyof MetricsTimeRange,
  endpoint: Endpoint
) => {
  const metric = endpoint?.metrics?.globalMetrics[value];
  if (!metric?.failed) {
    return null;
  }
  if (metric && Object.keys(metric)?.length > 0) {
    return Object.keys(metric?.failed)?.map((key) => ({
      name: key.replace("T", " ").replace("Z", ""),
      failed: metric?.failed[key],
      success: metric?.succes[key],
      latency: metric?.latency[key],
    }));
  }

  return [];
};

export const pieChartMapper = (
  value: keyof MetricsTimeRange,
  endpoint: Endpoint
) => {
  const response = endpoint?.metrics?.globalMetrics[value].httpCodesRepartition;

  if (response && Object.keys(response).length > 0) {
    const data = Object.entries(response)?.map(([key, count]) => ({
      name: key,
      value: count,
    }));
    return data;
  }

  return [];
};

export const backendChartMapper = (
  id: string,
  value: keyof MetricsTimeRange,
  endpoint: Endpoint
) => {
  if (endpoint?.metrics?.backendsMetrics[id]) {
    const metric = endpoint?.metrics?.backendsMetrics[id][value];
    if (!metric?.failed) {
      return null;
    } else {
      return Object.keys(metric?.failed)?.map((key) => ({
        name: key.replace("T", " ").replace("Z", ""),
        failed: metric.failed[key],
        success: metric.succes[key],
        latency: metric.latency[key],
      }));
    }
  }
};

export const backendPieChartMapper = (
  id: string,
  value: keyof MetricsTimeRange,
  endpoint: Endpoint
) => {
  if (endpoint?.metrics?.backendsMetrics[id]) {
    const response =
      endpoint?.metrics?.backendsMetrics[id][value].httpCodesRepartition;
    if (response && Object.keys(response).length > 0) {
      const data = Object.entries(response).map(([key, count]) => ({
        name: key,
        value: count,
      }));
      return data;
    }

    return [];
  }
};
export const overDate = [
  { value: "over1hours", label: "Over 1 hour" },
  { value: "over12hours", label: "Over 12 hours" },
  { value: "over24hours", label: "Over 24 hours" },
  { value: "over48hours", label: "Over 48 hours" },
  { value: "over72hours", label: "Over 72 hours" },
  { value: "over1week", label: "Over 1 week" },
  { value: "over15days", label: "Over 15 days" },
  { value: "over1month", label: "Over 1 month" },
  { value: "over6month", label: "Over 6 month" },
];
export const groupeGlobalMetrics = (endpoints: any) => {
  const groupedMetrics: any = {
    over1week: {},
    over1year: {},
    over15days: {},
    over1hours: {},
    over1month: {},
    over2years: {},
    over6month: {},
    over12hours: {},
    over24hours: {},
    over48hours: {},
    over72hours: {},
  };

  endpoints.forEach((endpoint: any) => {
    if (endpoint?.metrics && endpoint?.metrics?.globalMetrics) {
      for (const period in groupedMetrics) {
        if (endpoint?.metrics?.globalMetrics[period]) {
          const metrics = endpoint?.metrics?.globalMetrics[period];
          if (metrics?.latency && typeof metrics?.latency === "object") {
            for (const date in metrics?.latency) {
              if (metrics?.latency.hasOwnProperty(date)) {
                if (!groupedMetrics[period][date]) {
                  groupedMetrics[period][date] = {
                    latency: 0,
                    succes: 0,
                    failed: 0,
                    count: 0,
                  };
                }

                const latencyValue = metrics.latency[date];
                if (latencyValue > 0) {
                  groupedMetrics[period][date].latency += latencyValue;
                  groupedMetrics[period][date].count += 1;
                }
                groupedMetrics[period][date].succes += metrics.succes
                  ? metrics.succes[date] || 0
                  : 0;
                groupedMetrics[period][date].failed += metrics.failed
                  ? metrics.failed[date] || 0
                  : 0;
              }
            }
          }
        }
      }
    }
  });

  for (const period in groupedMetrics) {
    for (const date in groupedMetrics[period]) {
      const entry = groupedMetrics[period][date];
      if (entry.count > 0) {
        entry.latency = (entry.latency / entry.count).toFixed(0);
      }
      delete entry.count;
    }
  }

  return groupedMetrics;
};

export const groupedMetricsDataMapper = (
  value: keyof MetricsTimeRange,
  metrics: any
) => {
  const metric = metrics[value];
  if (Object.keys(metric).length === 0) {
    return [];
  }
  if (metric && Object.keys(metric)?.length > 0) {
    return Object.keys(metric)?.map((key) => ({
      name: key.replace("T", " ").replace("Z", ""),
      failed: metric[key].failed,
      success: metric[key].succes,
      latency: metric[key].latency,
    }));
  }
  return metrics;
};

export const calculatePercentage = (value: number, data: any): number => {
  const total = (data?.failedInstant || 0) + (data?.successInstant || 0);
  if (total === 0) {
    return 0;
  }
  return parseFloat((((value || 0) / total) * 100).toFixed(2));
};

export type ColorKeys =
  | "400"
  | "401"
  | "402"
  | "403"
  | "404"
  | "429"
  | "500"
  | "501"
  | "502"
  | "503"
  | "504"
  | "2xx_3xx"
  | "other";

export const COLORS = {
  "400": "#FFD700",
  "401": "#FFD700",
  "402": "#FFD700",
  "403": "#FFD700",
  "404": "#FFD700",
  "429": "#FFD700",
  "500": "#D32F2F",
  "501": "#D32F2F",
  "502": "#D32F2F",
  "503": "#D32F2F",
  "504": "#D32F2F",
  "2xx_3xx": "#2EA44F",
  other: "#6F4F37",
};

export const Labels = {
  "2xx_3xx": "Success (2xx_3xx)",
  "400": "Bad Request (400)",
  "401": "Unauthorized (401)",
  "402": "Payment Required (402)",
  "403": "Forbidden (403)",
  "404": "Not Found (404)",
  "429": "Too Many Requests (429)",
  "500": "Internal Server Error (500)",
  "501": "Not Implemented (501)",
  "502": "Bad Gateway (502)",
  "503": "Service Unavailable (503)",
  "504": "Gateway Timeout (504)",
  other: "Other",
};

export function generateRandomString(length: number) {
  const characters = "abcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const overDateValue = {
  over1hours: "over 1 hour",
  over12hours: "over 12 hours",
  over24hours: "over 24 hours",
  over48hours: "over 48 hours",
  over72hours: "over 72 hours",
  over1week: "over 1 week",
  over15days: "over 15 days",
  over1month: "over 1 month",
  over6month: "over 6 month",
  over1year: "over 1 year",
};

export function formatNumber(value: number) {
  if (value === undefined) {
    return 0;
  }
  if (value >= 1_000_000) {
    return (value / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M"; // Millions
  } else if (value >= 1_000) {
    return (value / 1_000).toFixed(1).replace(/\.0$/, "") + "k"; // Milliers
  } else {
    return value; // Autres nombres
  }
}

export function formatDuration(ms: number) {
  if (ms === undefined) {
    return 0;
  }
  const hours = Math.floor(ms / (1000 * 60 * 60));
  const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((ms % (1000 * 60)) / 1000);
  const milliseconds = ms % 1000;

  let result = "";
  if (hours > 0) result += `${hours}h `;
  if (minutes > 0) result += `${minutes}mn `;
  if (seconds > 0) result += `${seconds}s `;
  if (milliseconds > 0) result += `${milliseconds}ms`;
  return result.trim() || 0; // Supprime l'espace finale si elle existe
}

export function sortByDate(data: any) {
  return data.sort(
    (a: any, b: any) =>
      new Date(b.lastUpdatedDate).getTime() -
      new Date(a.lastUpdatedDate).getTime()
  );
}
export function timeAgo(dateStr: string) {
  const date = new Date(dateStr);
  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  let interval = Math.floor(seconds / 31536000);
  if (interval > 1) return `${interval}y ago`;

  interval = Math.floor(seconds / 2592000);
  if (interval > 1) return `${interval}m ago`;

  interval = Math.floor(seconds / 86400);
  if (interval > 1) return `${interval}d ago`;

  interval = Math.floor(seconds / 3600);
  if (interval > 1) return `${interval}h ago`;

  interval = Math.floor(seconds / 60);
  if (interval > 1) return `${interval}mn ago`;

  return `${Math.floor(seconds)}s ago`;
}

export const scope = [
  { value: "cluster", label: "Cluster" },
  { value: "environment", label: "Environment" },
];

export const security = [
  { value: "Enabled", label: "Enabled" },
  { value: "Disabled", label: "Disabled" },
];

export const urlPrefix = (org: any) => {
  if (org && org !== "default") {
    return `${org}.`;
  } else {
    return "";
  }
};

export const optionsRequests = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
  { label: "10", value: "10" },
  { label: "20", value: "20" },
  { label: "30", value: "30" },
  { label: "40", value: "40" },
  { label: "50", value: "50" },
  { label: "60", value: "60" },
  { label: "70", value: "70" },
  { label: "80", value: "80" },
  { label: "90", value: "90" },
  { label: "100", value: "100" },
  { label: "200", value: "200" },
  { label: "300", value: "300" },
  { label: "400", value: "400" },
  { label: "500", value: "500" },
  { label: "600", value: "600" },
  { label: "700", value: "700" },
  { label: "800", value: "800" },
  { label: "900", value: "900" },
  { label: "1000", value: "1000" },
  { label: "2000", value: "2000" },
  { label: "3000", value: "3000" },
  { label: "4000", value: "4000" },
  { label: "5000", value: "5000" },
  { label: "6000", value: "6000" },
  { label: "7000", value: "7000" },
  { label: "8000", value: "8000" },
  { label: "9000", value: "9000" },
  { label: "10000", value: "10000" },
  { label: "20000", value: "20000" },
  { label: "30000", value: "30000" },
  { label: "40000", value: "40000" },
  { label: "50000", value: "50000" },
  { label: "60000", value: "60000" },
  { label: "70000", value: "70000" },
  { label: "80000", value: "80000" },
  { label: "90000", value: "90000" },
  { label: "100000", value: "100000" },
];

export enum EAuthserverTypeOptions {
  oidc = "oidc",
  basic = "basic",
  token = "token",
}

export enum ERetryOnFilter {
  "5xx" = "5xx",
  "gateway-error" = "gateway-error",
  reset = "reset",
  "connect-failure" = "connect-failure"
}

export const isTokenValid = (token: string) => {
  if (!token) return false; // Aucun token
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded?.exp && decoded?.exp > currentTime;
  } catch (error) {
    console.log({ error })
    return false;
  }
};

export const deepEqualArray = (
  a: any,
  b: any,
  ignoredKeys: string[] = ['id', 'uniqueId']
): boolean => {
  if (a === b) return true;
  if (typeof a !== typeof b) return false;
  if (a === null || b === null) return a === b;
  if (a instanceof Map && b instanceof Map) {
    if (a.size !== b.size) return false;
    for (const [key, valueA] of a.entries()) {
      if (!b.has(key)) return false;
      const valueB = b.get(key);
      if (!deepEqualArray(valueA, valueB, ignoredKeys)) return false;
    }
    return true;
  }
  if (Array.isArray(a)) {
    if (!Array.isArray(b) || a.length !== b.length) return false;
    return a.every((item, index) => deepEqualArray(item, b[index], ignoredKeys));
  }
  if (typeof a === 'object' && typeof b === 'object') {
    const aKeys = Object.keys(a).filter((key) => !ignoredKeys.includes(key));
    const bKeys = Object.keys(b).filter((key) => !ignoredKeys.includes(key));

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every((key) => {
      if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
      return deepEqualArray(a[key], b[key], ignoredKeys);
    });
  }
  return a === b;
};

export function deepClone<T>(obj: T): T {
  if (obj === null || typeof obj !== 'object') return obj;

  if (obj instanceof Map) {
    const clonedMap = new Map();
    obj.forEach((value, key) => {
      clonedMap.set(deepClone(key), deepClone(value));
    });
    return clonedMap as T;
  }
  if (Array.isArray(obj)) {
    return obj.map((item) => deepClone(item)) as unknown as T;
  }
  if (obj instanceof Date) {
    return new Date(obj.getTime()) as T;
  }
  const clonedObj: any = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      clonedObj[key] = deepClone(obj[key]);
    }
  }
  return clonedObj;
}

export enum EBackendStatus {
  Online = "Online",
  Offline = "Offline",
}

export enum EBackendProtocol {
  Tls = "tls",
}

export const formatJsonString = (value: unknown) =>
  JSON.stringify(value, null, 2)
    .replace(/\[\s+"/g, '["')
    .replace(/",\s+"/g, '", "')
    .replace(/"\s+\]/g, '"]');

export const defaultAuth = [
  {
    methods: ["GET", "POST", "PUT"],
    paths: ["/*"],
    permisionType: "roles",
    permissions: ["user"],
  },
];
export const allSSL = [
  { label: "Edge", value: "edge" },
  { label: "Passthough", value: "passthrough" },
  { label: "Re-encrypt", value: "re-encrypt" },
  { label: "Unsecure", value: "unsecure" },
];
export const ipType = [
  { label: "None", value: "none" },
  { label: "Allow", value: "ipAllowCIDR" },
  { label: "Deny", value: "ipDenyCIDR" },
];
export const DEFAULT_IP_FILTER_VALUE = "0.0.0.0/0";

export const createDefaultIpFilterRow = (): IpFilterRow => ({
  type: "ipAllowCIDR",
  value: DEFAULT_IP_FILTER_VALUE,
});


export const extractIpList = (values?: string[] | null) =>
  Array.isArray(values)
    ? values
        .map((value) => (typeof value === "string" ? value.trim() : ""))
        .filter((value) => value.length)
    : [];

export const parseIpFilterPolicy = (policy?: IpFilterPolicy | null): IpFilterRow[] => {
  if (!policy) {
    return [createDefaultIpFilterRow()];
  }

  const allowValues = Array.from(
    new Set([
      ...extractIpList(policy.ipAllowCIDR),
      ...extractIpList(policy.allow),
    ])
  );
  const denyValues = Array.from(
    new Set([
      ...extractIpList(policy.ipDenyCIDR),
      ...extractIpList(policy.deny),
    ])
  );

  const rows: IpFilterRow[] = [
    ...allowValues.map((value) => ({ type: "ipAllowCIDR" as IpFilterType, value })),
    ...denyValues.map((value) => ({ type: "ipDenyCIDR" as IpFilterType, value })),
  ];

  return rows.length ? rows : [createDefaultIpFilterRow()];
};

export const trimIpFilterRows = (rows: IpFilterRow[]) =>
  rows.map((row) => ({
    type: row.type,
    value: row.value.trim(),
  }));

export const buildIpFilterPayload = (rows: IpFilterRow[], ipFilterPolicy: any) => {
  const trimmedRows = trimIpFilterRows(rows);
  const allow = trimmedRows
    .filter((row) => ipFilterPolicy === "ipAllowCIDR" && row.value.length)
    .map((row) => row.value);
  const deny = trimmedRows
    .filter((row) => ipFilterPolicy === "ipDenyCIDR" && row.value.length)
    .map((row) => row.value);

  const uniqueAllow = Array.from(new Set(allow));
  const uniqueDeny = Array.from(new Set(deny));

  const hasCustomIpFilters =
    uniqueDeny.length > 0 ||
    uniqueAllow.length > 1 ||
    uniqueAllow.some((value) => value !== DEFAULT_IP_FILTER_VALUE);

  if (!hasCustomIpFilters) {
    return null;
  }

  const allowPayload =
    uniqueAllow.length === 0
      ? undefined
      : uniqueAllow.length === 1 &&
          uniqueAllow[0] === DEFAULT_IP_FILTER_VALUE &&
          uniqueDeny.length > 0
        ? undefined
        : uniqueAllow;

  const denyPayload = uniqueDeny.length === 0 ? undefined : uniqueDeny;

  return {
    ...(allowPayload ? { ipAllowCIDR: allowPayload } : {}),
    ...(denyPayload ? { ipDenyCIDR: denyPayload } : {}),
  } as IpFilterPolicy;
};

export const validateIpFilterRows = (rows: IpFilterRow[]) =>
  rows.reduce<Record<number, string>>((acc, row, index) => {
    if (!row.value.trim()) {
      acc[index] = "Value is required";
    }
    return acc;
  }, {});

export const removeIpFilterError = (
  errors: Record<number, string>,
  index: number
): Record<number, string> => {
  if (!errors[index]) {
    return errors;
  }

  const { [index]: _removed, ...rest } = errors;
  return rest;
};

export const reindexErrorsAfterRemoval = (
  errors: Record<number, string>,
  removedIndex: number
) =>
  Object.keys(errors).reduce<Record<number, string>>((acc, key) => {
    const currentIndex = Number(key);
    if (currentIndex === removedIndex) {
      return acc;
    }
    const nextIndex = currentIndex > removedIndex ? currentIndex - 1 : currentIndex;
    acc[nextIndex] = errors[currentIndex];
    return acc;
  }, {});

export const transformAllowedPaths = (
  data: { method: string; paths: string[] }[]
) => {
  return data.reduce((acc, item) => {
    acc[item.method] = item.paths;
    return acc;
  }, {} as Record<string, string[]>);
};

